import { DataFile } from 'src/shared/types/data-file-interface'

export const getBackgroundImageStyleValue = (file?: DataFile | null) =>
  file ? `url("${file.path}")` : 'none'
